import styled from 'styled-components';
import { Span } from '../../element';

export const SpanComponentStyled = styled(Span)`
  color: red;
  font-size: 14px;
  font-family: 'Blinker', sans-serif;
`;
